import styles from "./InputWrapper.module.scss";

export default function InputWrapper({
  id,
  label,
  formState,
  children,
  required,
  width = "full",
  controlled,
  instructions,
}) {
  const errors = !controlled ? formState?.errors ?? {} : {};

  return (
    <div
      className={`inputWrapper ${styles.wrapper} ${
        styles[`${width}Width`]
      } ${width}Width`}
    >
      <label htmlFor={id} className={`${styles.label}`}>
        {label}
        {required && <span className={`${styles.required}`}>*</span>}
      </label>
      {instructions && (
        <span id={`${id}-instructions`} className={`${styles.instructions}`}>
          {instructions}
        </span>
      )}
      {children}
      {errors && errors[id] && (
        <div className={`${styles.error}`}>
          <span className={`${styles.errorMessage}`}>{errors[id].message}</span>
        </div>
      )}
    </div>
  );
}
